var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.images[0][0].exists !== null
    ? _c("div", [
        _c(
          "div",
          { staticClass: "vx-row mt-10" },
          _vm._l(_vm.images[0].slice(0, 3), function (image) {
            return _c(
              "div",
              {
                key: image.id,
                staticClass: "vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3",
              },
              [
                _c("vx-card", [
                  _c("div", { attrs: { slot: "no-body" }, slot: "no-body" }, [
                    _c("div", {
                      staticClass: "overlayed",
                      style: image.exists ? image.custom : image.default,
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "inline-flex",
                        "align-items": "center",
                      },
                    },
                    [
                      _c("h2", { staticClass: "mb-2" }, [
                        _vm._v(
                          "\n                          " +
                            _vm._s(image.text) +
                            "\n                      "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isAdmin() && image.exists
                        ? _c("vs-button", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Supprimer",
                                expression: "'Supprimer'",
                              },
                            ],
                            staticStyle: {
                              position: "absolute",
                              right: "55px",
                            },
                            attrs: {
                              id: "deleteImage_" + image.id,
                              color: "primary",
                              type: "border",
                              "icon-pack": "feather",
                              icon: "icon-trash",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteImage(image.id)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isAdmin()
                        ? _c("vs-button", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Modifier",
                                expression: "'Modifier'",
                              },
                            ],
                            staticStyle: {
                              position: "absolute",
                              right: "10px",
                            },
                            attrs: {
                              id: "modifyImage_" + image.id,
                              color: "primary",
                              type: "border",
                              "icon-pack": "feather",
                              icon: "icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.uploadPrompt(image.id)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vx-row mt-10" },
          [
            _vm._l(_vm.images[0].slice(3), function (image) {
              return _c(
                "div",
                {
                  key: image.id,
                  staticClass: "vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3",
                },
                [
                  false || image !== _vm.images[0][3]
                    ? _c("vx-card", [
                        _c(
                          "div",
                          { attrs: { slot: "no-body" }, slot: "no-body" },
                          [
                            _c("div", {
                              staticClass: "overlayed",
                              style: image.exists
                                ? image.custom
                                : image.default,
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "inline-flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c("h2", { staticClass: "mb-2" }, [
                              _vm._v(
                                "\n                          " +
                                  _vm._s(image.text) +
                                  "\n                      "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.isAdmin() && image.exists
                              ? _c("vs-button", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Supprimer",
                                      expression: "'Supprimer'",
                                    },
                                  ],
                                  staticStyle: {
                                    position: "absolute",
                                    right: "55px",
                                  },
                                  attrs: {
                                    id: "deleteImage_" + image.id,
                                    color: "primary",
                                    type: "border",
                                    "icon-pack": "feather",
                                    icon: "icon-trash",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteImage(image.id)
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isAdmin()
                              ? _c("vs-button", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Modifier",
                                      expression: "'Modifier'",
                                    },
                                  ],
                                  staticStyle: {
                                    position: "absolute",
                                    right: "10px",
                                  },
                                  attrs: {
                                    id: "modifyImage_" + image.id,
                                    color: "primary",
                                    type: "border",
                                    "icon-pack": "feather",
                                    icon: "icon-edit",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.uploadPrompt(image.id)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "DialogPrompt",
              {
                attrs: {
                  active: _vm.active,
                  title: `Importer une nouvelle image`,
                  "cancel-text": "Annuler",
                  "accept-text": "Importer",
                  "is-valid": true,
                },
                on: {
                  "update:active": function ($event) {
                    _vm.active = $event
                  },
                  cancel: function ($event) {
                    return _vm.close()
                  },
                  accept: function ($event) {
                    return _vm.startImport()
                  },
                },
              },
              [
                _c("div", { staticClass: "con-exemple-prompt" }, [
                  _c("div", { staticClass: "vx-row mb-6 ml-10" }, [
                    _c("span", [
                      _vm._v("Sélectionner un fichier (.jpeg, .png...) : "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "vx-row mb-6 ml-10" }, [
                    _c("input", {
                      staticClass: "w-full",
                      attrs: { type: "file", accept: "image/*", name: "file" },
                      on: { change: _vm.selectFile },
                    }),
                  ]),
                ]),
              ]
            ),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }